export enum NavigationSegments {
  ROOT = '',
  HOME = 'home',
  ITEM = 'item',
  ERROR = 'error',
}
